/**
 * El editor de los textos legales: solo lo que el sitio sabe publicar.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ ESTA BARRA Y EL SANEADO DEL SERVIDOR SON LA MISMA LISTA                  │
 * │                                                                          │
 * │ El backend limpia el HTML al guardarlo (`utils/legal.js`) y se queda con │
 * │ un puñado de etiquetas: párrafos, titulares, negrita, cursiva, listas,   │
 * │ enlaces, citas y tablas. Nada de `style` ni de `class`.                  │
 * │                                                                          │
 * │ Por eso esta barra NO lleva colores, resaltados, alineación ni tamaños   │
 * │ de letra, aunque el editor los sepa hacer: se escribirían, se guardarían │
 * │ y desaparecerían al recargar, que es la peor forma de enterarse.         │
 * │                                                                          │
 * │ Si algún día se añade una etiqueta al saneado, se añade aquí también.    │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * El aspecto —tipografía, tamaños, márgenes— lo pone la hoja de estilos de
 * sailradar.com. Así una política escrita hoy y otra dentro de dos años se
 * leen igual, en vez de arrastrar cada una el gusto de quien la escribió.
 */
export const configuracionLegal = {
	toolbar: {
		items: [
			'heading',
			'|',
			'bold',
			'italic',
			'underline',
			'|',
			'bulletedList',
			'numberedList',
			'|',
			'link',
			'blockQuote',
			'insertTable',
			'|',
			'removeFormat',
			'|',
			'undo',
			'redo',
		],
		shouldNotGroupWhenFull: false,
	},
	/**
	 * Los titulares empiezan en H2, no en H1.
	 *
	 * El H1 de la página es el título del documento, que lo pone la web. Dos
	 * H1 en la misma página es de las pocas cosas que un buscador señala como
	 * error de verdad.
	 */
	heading: {
		options: [
			{ model: 'paragraph', title: 'Párrafo', class: 'ck-heading_paragraph' },
			{ model: 'heading2', view: 'h2', title: 'Apartado', class: 'ck-heading_heading2' },
			{ model: 'heading3', view: 'h3', title: 'Subapartado', class: 'ck-heading_heading3' },
		],
	},
	table: {
		contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
	},
	link: {
		// Los enlaces de estos textos van a otras páginas del propio sitio o a
		// un correo. Lo de `target` y `rel` lo pone la web, no el texto.
		addTargetToExternalLinks: false,
	},
}
